import SearchBar from "./components/SearchBar";

const App  = () => {
  return (
    <div className="App">
      
      <header className="App-header">
        <span>WEATHER MASTER</span>  
      </header>

      <main>
        <div></div>
        <SearchBar/>
      </main>
      
    </div>
  );
}

export default App;
